var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.details["title"])+" ")]),_c('Bar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }